// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_user_dropdown_link-module__container--2NSck"};